export class PurchaseProductModel{
    id:number;
    details:string;
    deviceCount:number;
    displayPrice:number;
    price:number;
}